import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { translate } from 'i18n/i18n'

export const makeNumberRenderer = (o: {
  metaId?: string
  baseLabel: string
  render: (value: number | null) => string
}): ((
  value:
    | number
    | null
    | {
        min?: number | null
        max?: number | null
        average?: number | null
        sum?: number | null
      },
) => Array<{ id: string; value: string; label: string }>) => {
  const { metaId, baseLabel, render } = o
  const idAverage = metaId ? `${metaId}.average` : 'average'
  const idMax = metaId ? `${metaId}.max` : 'max'
  const idMin = metaId ? `${metaId}.min` : 'min'
  const idSum = metaId ? `${metaId}.sum` : 'sum'
  const idValue = metaId ? `${metaId}.value` : 'value'
  const labelAverage = twoItemLabel([baseLabel, translate.phrases.abbreviations('Average')])
  const labelMax = twoItemLabel([baseLabel, translate.phrases.abbreviations('Maximum')])
  const labelMin = twoItemLabel([baseLabel, translate.phrases.abbreviations('Minimum')])
  const labelSum = twoItemLabel([baseLabel, translate.phrases.abbreviations('Summation')])

  return (value) => {
    if (value !== null && typeof value === 'object') {
      const result: Array<{ id: string; value: string; label: string }> = []

      if (value.average !== undefined) {
        result.push({
          id: idAverage,
          value: render(value.average),
          label: labelAverage,
        })
      }

      if (value.max !== undefined) {
        result.push({
          id: idMax,
          value: render(value.max),
          label: labelMax,
        })
      }

      if (value.min !== undefined) {
        result.push({
          id: idMin,
          value: render(value.min),
          label: labelMin,
        })
      }

      if (value.sum !== undefined) {
        result.push({
          id: idSum,
          value: render(value.sum),
          label: labelSum,
        })
      }

      return result
    } else {
      return [
        {
          id: idValue,
          value: render(value),
          label: baseLabel,
        },
      ]
    }
  }
}
